/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum QaCheckResult {
  Ok = 'Ok',
  NotOk = 'NotOk',
  WarningOk = 'WarningOk',
  NotApplicable = 'NotApplicable'
}
